import React, { useEffect, useState } from 'react'
import { BiPlus, BiTrash } from 'react-icons/bi'
import './filter.css'

/**
 * ConditionGroupItem Component
 * 
 * Renders a filter condition group item (first-level condition within a filter group).
 * Manages field selection, operator selection, and connective (AND/OR) logic.
 * Updates parent array state when any condition property changes.
 * 
 * @param {Object} props - Component props
 * @param {string} props.connective - AND/OR connective logic (empty for first item)
 * @param {Function} props.setConnective - Setter for connective value
 * @param {number} props.id - Unique condition ID for array indexing
 * @param {Array} props.array - Current conditions array from parent
 * @param {Function} props.remove - Callback to remove this condition
 * @param {Function} props.update - Callback to update condition in array
 * @returns {JSX.Element} Condition row with field/operator/value selectors
 */

const fields = [
  'Name',
  'Entity type',
  'Description',
  'Reasons for shutdown',
  'Industry',
  'Categories',
  'Location',
  'Ownership status',
  'Stage of development',
  'Transactional model type',
  'Defensibility moats',
  'Last financing round',
  'Total raised',
  'Post-money valuation',
  'Transactional model type',
  'Last financing date',
  'No. of funding round(s)',
  'No. of investors',
  'Investors',
  'Total revenue',
  'Market capitalization',
  'No. of investments',
  'No. of acquisitions',
  'No. of board seats taken',
  'Competition',
  'Similar entities',
  'Management',
  'No. of employees',
  'Company reputation',
  'Contact info',
  'Operational duration',
  'Shutdown date',
  'Founded date',
  'Legal name',
  'Former legal name(s)',
  'Ticker',
  'Data room'
]

const operators = [
  'contains',
  'does not contain',
  'is',
  'is not',
  'is empty',
  'is not empty'
]

const rounds = [
  'undisclosed',
  'seed round',
  'series A',
  'series B',
  'grant',
  'private equity round',
  'funding round',
  'angel round',
  'debt financing',
  'product crowdfunding'
]

const ConditionGroupItem = ({
  connective,
  setConnective,
  id,
  array,
  remove,
  update
}) => {
  const [selectedField, setSelectedField] = useState(fields[0])
  const [selectedOperator, setSelectedOperator] = useState(operators[0])

  // useEffect everytime the overall array changes length
  useEffect(() => {
    if (id !== 0) {
      update(id, { ...array[id], connective: connective })
    }

    // if item is first in the array, the connective is null or empty
    if (id === 0) {
      update(id, { ...array[id], connective: '' })
    }
  }, [array.length])

  useEffect(() => {
    update(id, { ...array[id], connective: connective })
  }, [connective])

  return (
    <div className='flex' style={{ margin: '0.65rem 0rem' }}>
      <div
        className='w-300'
        style={{
          marginRight: '1rem',
          textAlign: 'right'
        }}
      >
        {id === 0 ? (
          <>Where</>
        ) : id === 1 ? (
          <select
            className='form-cell'
            value={connective}
            onChange={e => {
              update(id, { ...array[id], connective: e.target.value })
              setConnective(e.target.value)
            }}
          >
            <option className='option' value='and'>
              and
            </option>
            <option className='option' value='or'>
              or
            </option>
          </select>
        ) : (
          connective
        )}
      </div>
      <div className='flex w-full group-row'>
        <div className='group-row-text'>Add conditions or condition groups</div>
        <div className='flex group-row-icons'>
          <div
            className='flex pointer'
            style={{ whiteSpace: 'nowrap' }}
          // onClick={handleAddCondition}
          >
            <BiPlus />
          </div>
          <div className='condition-icon pointer' onClick={() => remove(id)}>
            <BiTrash />
          </div>
        </div>
      </div>
    </div>
  )
}

export default ConditionGroupItem
